import React from 'react'
import './Random.css'

export default function Projects() {
  return (
    <>
      <div className='random_div'>
      <h2>THis is the Projects Page.</h2>
      </div>
    </>
  )
}
